import { Row } from 'antd'
import GuardianInfo from './GuardianHistory'
import GuardianGeneral from './GuardianGeneral'
const GuardianBasicInfo = ({ parent }: any) => {
  return (
    <Row gutter={10} className="bg-grey container padding-top-10">
      <GuardianInfo data={parent} />
      <GuardianGeneral data={parent} />
    </Row>
  )
}

export default GuardianBasicInfo
